"use client";
import * as React from "react";

interface State { error: Error | null }

export class ErrorBoundary extends React.Component<
  { children: React.ReactNode; fallback?: (err: Error, reset: () => void) => React.ReactNode },
  State
> {
  override state: State = { error: null };
  static getDerivedStateFromError(error: Error): State { return { error }; }
  override componentDidCatch(error: Error, info: React.ErrorInfo) {
    // \u53ef\u63a5\u5165 Sentry \u7b49\u4e0a\u62a5
    if (typeof window !== "undefined") {
      // eslint-disable-next-line no-console
      console.error("[ErrorBoundary]", error, info.componentStack);
    }
  }
  reset = () => this.setState({ error: null });
  override render() {
    if (this.state.error) {
      if (this.props.fallback) return this.props.fallback(this.state.error, this.reset);
      return (
        <div className="mx-auto max-w-md p-6 text-center">
          <div className="rounded-lg border border-red-200 bg-red-50 p-5">
            <h2 className="text-base font-semibold text-red-700">\u9875\u9762\u51fa\u9519\u4e86</h2>
            <p className="mt-2 text-[13px] text-red-600">{this.state.error.message}</p>
            <button
              onClick={this.reset}
              className="mt-3 rounded bg-red-600 px-3 py-1.5 text-[13px] font-medium text-white hover:bg-red-700"
            >\u91cd\u8bd5</button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}